import {PlayerEvent} from './player-event';

export class PlayerProfileEventMatch
{
  id: number;

  eventId: number;
  matchId: number;
  database: number;
  mandantKey: number;
  mandantSubKey: number;

  datetime: Date;

  roundName: string;
  participantHome: string;
  participantGuest: string;
  participantHomeId: number;
  participantGuestId: number;

  statusCd: string;

  gameNr: number;
  setsHome: number;
  setsAway: number;
  legsHome: number;
  legsAway: number;

  deleted: boolean;

  event: PlayerEvent;

  public static initData(data: PlayerProfileEventMatch): void
  {
    if (data)
    {
      if (data.datetime)
      {
        data.datetime = new Date(data.datetime);
        if (data.event && data.eventId)
          data.event.eventId = data.eventId;
      }
    }
  }
}
